import { arrayMove } from '@dnd-kit/sortable'

export const FLOW_SEPARATOR_ID = 'flow-separator'

/**
 * Computes the new flow items array after a drag-over event in flow mode.
 * Returns the original array unchanged if the move is disallowed.
 *
 * Rules:
 * - Unordered items cannot be reordered within the unordered section.
 * - Ordered items cannot be moved back to the unordered section.
 * - Unordered items CAN be moved to the ordered section (including the first position).
 */
export function computeFlowDragOver(
  items: string[],
  activeId: string,
  overId: string,
  separatorId: string = FLOW_SEPARATOR_ID
): string[] {
  const oldIndex = items.indexOf(activeId)
  const newIndex = items.indexOf(overId)
  if (oldIndex === -1 || newIndex === -1) return items

  const separatorIndex = items.indexOf(separatorId)
  if (separatorIndex === -1) return items

  const wasOrdered = oldIndex > separatorIndex
  const wasUnordered = oldIndex < separatorIndex

  // Disallow reordering *within* the Unordered section.
  // An unordered item dragged over another unordered item or staying
  // in the unordered zone should not move.  But dragging over the
  // separator itself is how the user places it as the first ordered item,
  // so that must be allowed.
  if (wasUnordered && newIndex < separatorIndex) {
    return items
  }

  // Prevent ordered items from moving to unordered section or onto the separator
  if (wasOrdered && newIndex <= separatorIndex) {
    return items
  }

  return arrayMove(items, oldIndex, newIndex)
}
